<template>
  <div class="container">
    <Empty v-if="isWrong" image="error" description="获取产品信息出错">
      <Button round type="danger" class="bottom-button" @click="getData(id)">点击重试</Button>
    </Empty>
    <div v-else>
      <div class="display">
        <Swipe :autoplay="3000">
          <SwipeItem v-for="(item , index) in productData.proPicDTOS" :key="index">
            <img class="swipeImage" :src="item.url"/>
          </SwipeItem>
        </Swipe>
      </div>
      <div class="title">
        <span>{{ productData.name }}</span>
      </div>
      <div class="tips">
        商品详情
      </div>
      <div class="detail">
        <div v-html="productData.detail">
        </div>
      </div>
      <Button v-if="can" type="danger" class="paybtn" round @click="toPay">立即兑换</Button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {Button, Divider, Empty, Swipe, SwipeItem, Dialog, Toast} from 'vant'
import Footer from "../components/Footer";
import store from "../store";
import config from "../config";
export default {
  name: "Detail",
  components: {
    Footer,
    Button,
    Divider,
    Empty,
    Swipe,
    SwipeItem
  },
  data () {
    return {
      id: '',
      sharedStore: store.state,
      productData: {},
      isWrong: false
    }
  },
  computed: {
    can () {
      return !Boolean(+this.$route.query.cant)
    }
  },
  methods: {
    getData (id) {
      axios.get(`${config.publicPath}/exchange-api/api/product/${id}`).then(res => {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.isWrong = false
          this.productData = data
        } else {
          this.isWrong = true
          Toast.fail(msg);
        }
      })
    },
    toPay () {
      const { token, status } = this.sharedStore
      if (!token) {
        this.$router.push({
          path: '/'
        })
      } else {
        if (status === 1) {
          Dialog.confirm({
            message: '您的卡号已兑换，如需购买更多，请联系客服',
            showCancelButton: false,
            confirmButtonColor: '#1989fa',
            confirmButtonText: '我知道了',
          })
        } else {
          this.$router.push({
            path: '/address',
            query: this.productData
          })
        }
      }
    }
  },
  mounted() {
    const { id } = this.$route.params
    if (id) {
      this.id = id
      this.getData(id)
    }
  }
}
</script>

<style scoped lang="less">
.container {
  padding-bottom: 55px;
}
.display {

  .swipeImage {
    width: 100%;
    object-fit: contain;
  }
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px 20px;
  border-bottom: solid 4px #e0e0e0;
  margin-bottom: 30px;


  & > span {
    flex: 1;
  }

  button {
    padding: 4px 20px;
    width: 116px;
  }
}


.tips {
  padding: 0 10px;
  margin: 10px 0 10px 10px;
  font-size: 20px;
  font-weight: bold;
  border-left: solid 2px orange;
}


.detail {
  padding: 0 10px;
  &  /deep/ img {
      width: 100%;
  }
}

.paybtn {
  position: fixed;
  width: 100%;
  bottom: 50px;
}

</style>